import { render, staticRenderFns } from "./LiabilitiesLoansYN.vue?vue&type=template&id=6a533c1c"
import script from "./LiabilitiesLoansYN.vue?vue&type=script&lang=js"
export * from "./LiabilitiesLoansYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports